module.exports = __webpack_public_path__ + "media/images/icons/file_dollar-cd1ee968e39cef64b24ca81a2faa1af8.svg";